module.exports = __webpack_public_path__ + "static/media/forma-azul.933317a2.svg";